import React, { useEffect } from 'react';
import { useTheme } from './ThemeContext';
import { Link } from 'react-router-dom';

export default function ThemeToggleButton() {
  const { mode, toggle } = useTheme();

  useEffect(() => {
    if (mode === 'white') {
      document.getElementById('bgChgBtn').style.backgroundColor = '#000';
    } else {
      document.getElementById('bgChgBtn').style.backgroundColor = '#fff';
    }
  }, [mode]);

  return (
    <Link onClick={toggle}>
        <div id="bgChgBtn" style={{display:"block", alignItems:"center", padding:"12px", width:"15px", backgroundColor:"#fff", borderRadius:"50%"}}></div>
    </Link>
  );
}
